import React from "react";
import S from './Questions.module.scss';
import { Accordion } from "@mantine/core";

interface IProps {
    questions?: any;
    event?: any;
}

export const Questions = ({ questions, event }: IProps) => {
    const items = questions.map((item: any) => (
        <Accordion.Item key={item.id} value={item.id} className={S.accordionItem}>
            <Accordion.Control className={S.accordionControl}>
                {item.question}
            </Accordion.Control>
            <Accordion.Panel>
                <div className={S.accordionPanel}>
                    <div className={S.accordionPanelText}>{item.text}</div>
                    {item?.paragraph && (
                        <div className={S.accordionPanelParagraphList}>
                            {item?.paragraph?.map((paragraph: any) => (
                                <div className={paragraph?.number ? S.accordionPanelParagraphDivNumber : S.accordionPanelParagraphDiv}>
                                    {paragraph?.number ? (
                                        <div className={event === 5 ? S.liStyleNumberLogistics : S.liStyleNumber}>{paragraph?.number}.</div>
                                    ) : (
                                        <li className={S.liStyle}/>
                                    )}
                                    <div key={paragraph?.id} className={S.accordionPanelParagraph}>
                                        <span>{paragraph?.title}</span> {paragraph?.text}
                                    </div>
                                </div>
                            ))}
                        </div>
                    )}
                    {item?.textTwo && <div className={S.accordionPanelText}>{item?.textTwo}</div>}
                    <div/>
                </div>
            </Accordion.Panel>
        </Accordion.Item>
    ))
    return (
        <div className={S.contentDiv}>
            <Accordion
                variant="contained"
                multiple
                defaultValue={[]}
                className={S.accordion}
            >
                {items}
            </Accordion>
        </div>
    );
};